import React from 'react';
import { classNames } from '../../utils/classNames';

export type EmptyStateProps = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
};

export const EmptyState: React.FC<EmptyStateProps> = ({ icon, title, description, actions, className }) => (
  <div
    className={classNames(
      'flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center',
      className
    )}
  >
    {icon ? <div className="flex h-16 w-16 items-center justify-center rounded-full bg-surface-subtle text-primary-500">{icon}</div> : null}
    <p className="text-lg font-semibold text-slate-900">{title}</p>
    {description ? <p className="max-w-sm text-sm text-slate-500">{description}</p> : null}
    {actions ? <div className="mt-2 flex items-center gap-2">{actions}</div> : null}
  </div>
);

export default EmptyState;
